import type {
  LineItemFragmentFragment,
  WishlistLineItemsFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import type { ReactNode } from 'react';

export const isCartPrice = (
  price: LineItemFragmentFragment['price'] | WishlistLineItemsFragmentFragment['price'],
): price is LineItemFragmentFragment['price'] =>
  (price as LineItemFragmentFragment['price']).discount !== undefined;
export const isReactNodeString = (node: ReactNode): node is string => typeof node === 'string';
